// extracted by mini-css-extract-plugin
module.exports = {"announcement":"Announcement_announcement__3RWrZ","heading":"Announcement_heading__qiQYA"};